import { displayToast } from "../../../helpers/notification";
import { ReferralTypes as Type } from "../../types/referral";


export function getReferralListRequest(body: any) {
  return {
    type: Type.GET_REFERRAL_LIST_REQUEST,
    body: body
  };
}

export function getReferralListRequestSuccess(data: any) {
  return {
    type: Type.GET_REFERRAL_LIST_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getReferralListRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_REFERRAL_LIST_REQUEST_FAILURE,
    error: error,
  };

}